
/**
 * Get connection status
 * @returns {Promise<{effectiveType: string, downlink: number, rtt: number, tone: string, value: string}>}
 */
export const getConnectionStatus = async () => {
  try {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    
    if (connection) {
      const effectiveType = connection.effectiveType || 'unknown';
      const downlink = connection.downlink || 0;
      const rtt = connection.rtt || 0;
      
      // Determine tone based on connection quality
      let tone = 'ok';
      let value = 'Good';
      
      if (effectiveType === 'slow-2g' || effectiveType === '2g') {
        tone = 'error';
        value = 'Poor';
      } else if (effectiveType === '3g' || downlink < 1.5) {
        tone = 'warning';
        value = 'Fair';
      } else if (effectiveType === '4g' && downlink >= 1.5) {
        tone = 'ok';
        value = 'Good';
      }
      
      return {
        effectiveType,
        downlink,
        rtt,
        tone,
        value,
      };
    }
  } catch (error) {
    console.warn('Connection API not available:', error);
  }
  
  // Fallback: assume good connection
  return {
    effectiveType: 'unknown',
    downlink: 0,
    rtt: 0,
    tone: 'ok',
    value: 'Good',
  };
};


export const monitorConnectionStatus = (callback) => {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  
  if (connection) {
    const updateStatus = async () => {
      const status = await getConnectionStatus();
      callback(status);
    };
    
    const changeListener = () => updateStatus();
    
    connection.addEventListener('change', changeListener);
    
    updateStatus();
    
    return () => {
      connection.removeEventListener('change', changeListener);
    };
  } else {
    getConnectionStatus().then(callback);
    return () => {}; // No-op cleanup
  }
};

